import React from 'react';
import { Home, ShoppingCart, Package, Tag, User } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAppStore } from '../store';
export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeShoppingItems = useAppStore(state => state.shoppingList.filter(item => !item.isCompleted).length);
  const tabs = [{
    id: 'home',
    path: '/',
    icon: Home,
    label: 'Home'
  }, {
    id: 'shop',
    path: '/shop',
    icon: ShoppingCart,
    label: 'Boodschappen'
  }, {
    id: 'stock',
    path: '/stock',
    icon: Package,
    label: 'Voorraad'
  }, {
    id: 'deals',
    path: '/deals',
    icon: Tag,
    label: 'Aanbiedingen'
  }, {
    id: 'profile',
    path: '/profile',
    icon: User,
    label: 'Profiel'
  }];
  return <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border pb-safe z-50" data-id="element-3181" data-mp="1tzmvusod9064">
      <div className="flex justify-around items-center h-16 px-2" data-id="element-3182" data-mp="15535r8ga2ym">
        {tabs.map(tab => {
        const isActive = location.pathname === tab.path;
        const Icon = tab.icon;
        return <button key={tab.id} onClick={() => navigate(tab.path)} className={`relative flex h-full w-16 flex-col items-center justify-center space-y-1 rounded-xl transition-colors focus:outline-none focus:ring-2 focus:ring-primary ${isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground'}`} aria-label={tab.id === 'shop' && activeShoppingItems > 0 ? `${tab.label}, ${activeShoppingItems} open` : tab.label} aria-current={isActive ? 'page' : undefined} data-id="element-3183" data-mp="3oebi9bjfwozy">
              <div className="relative flex h-11 w-11 items-center justify-center" data-id="element-3184" data-mp="17s0o42hme7r1">
                {isActive && <motion.div layoutId="bottomNavActiveBg" className="absolute inset-0 bg-primary/10 rounded-full" transition={{
              type: 'spring',
              stiffness: 300,
              damping: 25
            }} data-id="element-3185" data-mp="2gpibc1ilm5du" />}
                <motion.div animate={{
              scale: isActive ? 1.1 : 1
            }} transition={{
              type: 'spring',
              stiffness: 400,
              damping: 17
            }} className="relative z-10" data-id="element-3186" data-mp="2zexb7smjsogn">
                  <Icon size={20} className={isActive ? 'fill-primary/20' : ''} data-id="element-3187" data-mp="2lmh1k8z55s6r" />
                </motion.div>
                {tab.id === 'shop' && activeShoppingItems > 0 && <span className="absolute right-0 top-0 z-20 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold leading-none text-primary-foreground" data-id="element-3188" data-mp="3ea4lrmwi2gsv">
                    {activeShoppingItems > 9 ? '9+' : activeShoppingItems}
                  </span>}
              </div>
              <span className="text-[10px] font-medium z-10" data-id="element-3189" data-mp="3i8xydfphmqh">{tab.label}</span>
              {isActive && <motion.div layoutId="bottomNavActiveIndicator" className="absolute -bottom-1 w-4 h-1 rounded-full bg-primary" transition={{
            type: 'spring',
            stiffness: 300,
            damping: 25
          }} data-id="element-3190" data-mp="8hlvpt848e7u" />}
            </button>;
      })}
      </div>
    </nav>;
}